import { IconButton, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

function MyListAddButton({ onClick, sx, ...others }) {
  return (
    <Tooltip title="Add to My List" placement="top">
      <IconButton color="inherit" onClick={onClick} sx={sx} {...others}>
        <AddIcon />
      </IconButton>
    </Tooltip>
  );
}

export default MyListAddButton;
